import { ADVANCED, PATH_EDIT, PATH_PREVIEW, PATH_STORY, PATH_TEMPLATE } from '@opengov/stories-shared/constants';

export const PATH_MAINTENANCE = 'maintenance';

export const storiesSettingsPath = (entitySubdomain: string, tab?: string) => {
  return `/stories/settings/${entitySubdomain}${tab === ADVANCED ? '/advanced' : ''}`;
};

export const storyListPath = (entitySubdomain: string) => `/stories/${entitySubdomain}/stories`;

export const draftListPath = (entitySubdomain: string) => `/stories/${entitySubdomain}/drafts`;

export const createFromTemplatePath = (entitySubdomain: string) => `/stories/${entitySubdomain}/create-from-template`;

export const templateListPath = (entitySubdomain: string) => `/stories/${entitySubdomain}/templates`;

export const folderListPath = (entitySubdomain: string, folderId: string) =>
  `/stories/${entitySubdomain}/folders/${folderId}`;

export const storyViewPath = (entitySubdomain: string, storyId: string, isTemplate?: boolean) =>
  `/stories/${entitySubdomain}/${isTemplate ? PATH_TEMPLATE : PATH_STORY}/${storyId}`;

export const publicationStoryViewPath = (
  entitySubdomain: string,
  storyId: string,
  isTemplate?: boolean,
  publicationId?: string
) => `/stories/${entitySubdomain}/publication/${publicationId}/${isTemplate ? PATH_TEMPLATE : PATH_STORY}/${storyId}`;

export const storyEditPath = (entitySubdomain: string, storyId: string, isTemplate?: boolean) =>
  `/stories/${entitySubdomain}/${isTemplate ? PATH_TEMPLATE : PATH_STORY}/${storyId}/${PATH_EDIT}`;

export const publicationStoryEditPath = (
  entitySubdomain: string,
  storyId: string,
  isTemplate?: boolean,
  publicationId?: string
) =>
  `/stories/${entitySubdomain}/publication/${publicationId}/${isTemplate ? PATH_TEMPLATE : PATH_STORY
  }/${storyId}/${PATH_EDIT}`;

export const storyPreviewPath = (entitySubdomain: string, storyId: string, isTemplate?: boolean) =>
  `/stories/${entitySubdomain}/${isTemplate ? PATH_TEMPLATE : PATH_STORY}/${storyId}/${PATH_PREVIEW}`;

export const maintenancePath = (entitySubdomain: string) => `/stories/${entitySubdomain}/${PATH_MAINTENANCE}`;

export const organizeStoriesAndFoldersPath = (entitySubdomain: string, folderId: string, rootId: string) =>
  `/stories/${entitySubdomain}/folders/${rootId}/organize/${folderId}`;

export const publicationListPath = (entitySubdomain: string) => `/stories/${entitySubdomain}/publications`;

export const publicationViewPath = (entitySubdomain: string, publicationId: string, copyPublicationJobId?: string) =>
  `/stories/${entitySubdomain}/publications/${publicationId}/stories${!copyPublicationJobId ? '' : `/copy-process/${copyPublicationJobId}`
  }`;

export const publicationReportEmbedsPath = (entitySubdomain: string, publicationId: string) =>
  `/stories/${entitySubdomain}/publications/${publicationId}/embedded-reports`;

export const publicationCustomReportPath = (entitySubdomain: string, publicationId: string) =>
  `/stories/${entitySubdomain}/publications/${publicationId}/custom-reports`;

export const publicationTemplateListPath = (entitySubdomain: string, publicationId: string) =>
  `/stories/${entitySubdomain}/publications/${publicationId}/create-from-template`;

export const publicationFolderListPath = (entitySubdomain: string, publicationId: string, sectionId: string) =>
  `/stories/${entitySubdomain}/publications/${publicationId}/sections/${sectionId}`;

export const organizeSectionAndStoriesPath = (
  entitySubdomain: string,
  publicationId: string,
  sectionId: string,
  selectedSectionId: string
) => `/stories/${entitySubdomain}/publications/${publicationId}/sections/${sectionId}/organize/${selectedSectionId}`;

export const previewOnlinePublicatioPath = (entitySubdomain: string, publicationId: string) =>
  `/stories/${entitySubdomain}/publications/${publicationId}/onlinePublication/preview`;

export const setupOnlinePublicatioPath = (entitySubdomain: string, publicationId: string) =>
  `/stories/${entitySubdomain}/publications/${publicationId}/onlinePublication`;

export const setupOnlinePublicatioSelectTabPath = (entitySubdomain: string, publicationId: string, tabId?: string) =>
  tabId
    ? `/stories/${entitySubdomain}/publications/${publicationId}/onlinePublication/${tabId}`
    : `/stories/${entitySubdomain}/publications/${publicationId}/onlinePublication`;

export const onlinePublicatioSelectMenuPath = (entitySubdomain: string, publicationId: string, menuId: string) =>
  `/stories/${entitySubdomain}/publications/${publicationId}/onlinePublication/menus/${menuId}`;

export const publicationCustomCssPath = (entitySubdomain: string, publicationId: string, storyId?: string) =>
  `/stories/${entitySubdomain}/publications/${publicationId}/custom-css${!storyId ? '' : `/${storyId}`}`;

export const publicationSetupPDFPath = (entitySubdomain: string, publicationId: string) =>
  `/stories/${entitySubdomain}/publications/${publicationId}/setup-pdf`;

export const sectionSetupPDFPath = (entitySubdomain: string, sectionId: string) =>
  `/stories/${entitySubdomain}/sections/${sectionId}/setup-pdf`;
export const storySetupPDFPath = (entitySubdomain: string, storyId: string) =>
  `/stories/${entitySubdomain}/story/${storyId}/setup-pdf`;

export const publicationStorySetupPDFPath = (entitySubdomain: string, storyId: string, publicationId: string) =>
  `/stories/${entitySubdomain}/publications/${publicationId}/story/${storyId}/setup-pdf`;
